{
  "{account} needs to sign in again.": "{account} deve accedere di nuovo.",
  "{account} no longer has access to Johku Hub.": "{account} non ha più accesso a Johku Hub.",
  "{done} of {total}": "{done} di {total}",
  "{left} of {total} left": "{left} di {total} rimanenti",
  "{n} by email": "{n} tramite email",
  "{n} by push": "{n} tramite notifica",
  "{n} customer waiting for a reply": "{n} cliente in attesa di risposta",
  "{n} customers waiting for a reply": "{n} clienti in attesa di risposta",
  "{n} let in on this phone": "{n} fatti entrare con questo telefono",
  "{n} message": "{n} messaggio",
  "{n} message hasn't been sent yet and will be lost.": "{n} messaggio non è ancora stato inviato e andrà perso.",
  "{n} messages": "{n} messaggi",
  "{n} messages haven't been sent yet and will be lost.": "{n} messaggi non sono ancora stati inviati e andranno persi.",
  "{n} more: search by name.": "Altri {n}: cerca per nome.",
  "{n} of {total}": "{n} di {total}",
  "{n} pcs": "{n} pz",
  "{n} shop chosen": "{n} negozio scelto",
  "{n} shops chosen": "{n} negozi scelti",
  "{n} ticket": "{n} biglietto",
  "{n} tickets": "{n} biglietti",
  "{n} unread": "{n} non letti",
  "{n} unread conversation": "{n} conversazione non letta",
  "{n} unread conversations": "{n} conversazioni non lette",
  "{n} use left": "{n} utilizzo rimanente",
  "{n} uses left": "{n} utilizzi rimanenti",
  "{name} ({n} member)": "{name} ({n} membro)",
  "{name} ({n} members)": "{name} ({n} membri)",
  "{name} and {n} more": "{name} e altri {n}",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} ti ha inviato un messaggio su Johku Hub ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} ti ha inviato un messaggio su Johku Hub.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} può vendere i suoi prodotti nel tuo canale di vendita. Quando accettano, Johku lo attiva.",
  "{shop} sent you a message about your order {order}.": "{shop} ti ha inviato un messaggio sul tuo ordine {order}.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} vorrebbe parlare con voi. Rispondi o accetta per continuare.",
  "{sold} of {seats} sold": "{sold} di {seats} venduti",
  "A Bluetooth or USB scanner that types the code, as in the POS's ticket reader.": "Uno scanner Bluetooth o USB che digita il codice, come nel lettore biglietti della cassa.",
  "About Johku": "Informazioni su Johku",
  "Accept": "Accetta",
  "Accepted the offer: {channel}, {commission} % commission.": "Ha accettato l'offerta: {channel}, commissione del {commission} %.",
  "Accepted, being put into effect in Johku": "Accettata, in attivazione su Johku",
  "Accepted, but Johku couldn't put it into effect: {error}": "Accettata, ma Johku non è riuscito ad attivarla: {error}",
  "Accepted, in effect in Johku": "Accettata, attiva su Johku",
  "Access and instructions": "Istruzioni di accesso e utilizzo",
  "Accounts": "Conti",
  "Accounts and settings": "Account e impostazioni",
  "Add account": "Aggiungi account",
  "Add an account": "Aggiungi un account",
  "All": "Tutti",
  "All caught up": "Tutto letto",
  "All incidents": "Tutti i disservizi",
  "All orders": "Tutti gli ordini",
  "All shops": "Tutti i negozi",
  "All your shops ({n})": "Tutti i tuoi negozi ({n})",
  "Allow": "Consenti",
  "Allow {app} to use Johku Hub?": "Consentire a {app} di usare Johku Hub?",
  "Already used": "Già usato",
  "an assistant": "un assistente",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "Un assistente chiede di usare le tue conversazioni su Johku Hub. Accedi prima.",
  "As {name}": "Come {name}",
  "Ask the shop": "Chiedi al negozio",
  "Attach a file": "Allega un file",
  "Back": "Indietro",
  "Between organisations": "Tra organizzazioni",
  "Booking": "Prenotazione",
  "Can't load the collections right now.": "Impossibile caricare le collezioni in questo momento.",
  "Can't load the list of organisations right now.": "Al momento non è possibile caricare l'elenco delle organizzazioni.",
  "Can't reach Johku Hub. Check your connection and try again.": "Impossibile raggiungere Johku Hub. Controlla la connessione e riprova.",
  "Cancel": "Annulla",
  "Cancelled": "Annullato",
  "Cause found, being fixed": "Causa individuata, in risoluzione",
  "Check in": "Check-in",
  "Check out": "Check-out",
  "Check-in opens {time}.": "Il check-in apre {time}.",
  "Checked in {time}": "Check-in effettuato {time}",
  "Checked out {time}": "Check-out effettuato {time}",
  "Checking in…": "Check-in in corso…",
  "Checking out…": "Check-out in corso…",
  "Checking the ticket…": "Controllo del biglietto…",
  "Choose a conversation": "Scegli una conversazione",
  "Choose resources and start times": "Scegli risorse e orari di inizio",
  "Choose the seats to let in": "Scegli i posti da far entrare",
  "Choose the shows to scan for": "Scegli gli spettacoli da controllare",
  "Chosen shops": "Negozi scelti",
  "Close": "Chiudi",
  "Code sent to {email}": "Codice inviato a {email}",
  "Codes": "Codici",
  "Commission (%)": "Commissione (%)",
  "Confirmed": "Confermato",
  "Conversation": "Conversazione",
  "Conversation with the shop": "Conversazione con il negozio",
  "Conversations with the Johku team and shops show up here.": "Le conversazioni con il team Johku e con i negozi compaiono qui.",
  "Copied": "Copiato",
  "Copy the code": "Copia il codice",
  "customer": "cliente",
  "Customer": "Cliente",
  "Decline": "Rifiuta",
  "Declined": "Rifiutata",
  "Declined the offer.": "Ha rifiutato l'offerta.",
  "Deny": "Nega",
  "Done": "Fatto",
  "Download": "Scarica",
  "Downloading {name}": "Download di {name}",
  "E.g. Card payments fail": "Es. I pagamenti con carta non vanno a buon fine",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Ogni membro lo riceve in una conversazione tutta sua con il negozio, e le risposte ti arrivano una per una.",
  "Email address": "Indirizzo email",
  "Email those who don't have the app": "Invia un'email a chi non ha l'app",
  "Event times, cancellations and the shop's replies.": "Orari degli eventi, cancellazioni e risposte del negozio.",
  "Every shop": "Tutti i negozi",
  "Everything you've bought from Johku shops, in one place.": "Tutto ciò che hai acquistato nei negozi Johku, in un unico posto.",
  "Expired {date}": "Scaduto il {date}",
  "Find a shop": "Cerca un negozio",
  "Fixed, monitoring": "Risolto, sotto osservazione",
  "For": "Per",
  "For every shop": "Per tutti i negozi",
  "For: {shops}": "Per: {shops}",
  "Get started": "Per iniziare",
  "Get told about new messages": "Ricevi avvisi sui nuovi messaggi",
  "Getting the shows…": "Caricamento degli spettacoli…",
  "Getting the tickets…": "Caricamento dei biglietti…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Le carte regalo e gli altri codici che acquisti nei negozi Johku compaiono qui.",
  "Hide": "Nascondi",
  "Hide used and expired codes": "Nascondi i codici usati e scaduti",
  "Home": "Home",
  "Hub may not use the camera. Allow it in the phone's settings.": "Hub non può usare la fotocamera. Consentilo nelle impostazioni del telefono.",
  "In messages": "Nei messaggi",
  "Incidents": "Disservizi",
  "Incidents in Johku": "Disservizi su Johku",
  "Investigating": "In verifica",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "È valido per 10 minuti. Se non l'hai richiesto, puoi ignorare questa email.",
  "It opens signed in, and stays open in the background": "Si apre con l'accesso già effettuato e resta aperta in background",
  "It sees only what you see in Johku Hub, and every use is logged.": "Vede solo ciò che vedi tu su Johku Hub e ogni utilizzo viene registrato.",
  "Johku account": "Account Johku",
  "Johku agreement": "Contratto Johku",
  "Johku App": "Johku App",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub non funziona al momento. Riprova tra poco.",
  "Johku Hub sign-in code: {code}": "Codice di accesso a Johku Hub: {code}",
  "Johku status: {title}": "Stato di Johku: {title}",
  "Kind of conversation": "Tipo di conversazione",
  "Know when things change": "Sappi quando qualcosa cambia",
  "Language": "Lingua",
  "Let in {n}": "Fai entrare ({n})",
  "Let in: {n} seat": "Entrato: {n} posto",
  "Let in: {n} seats": "Entrati: {n} posti",
  "Light off": "Spegni la luce",
  "Light on": "Accendi la luce",
  "Loading…": "Caricamento…",
  "Main menu": "Menù principale",
  "Maintenance": "Manutenzione",
  "Make an offer": "Fai un'offerta",
  "Members of": "Membri di",
  "Members' replies come as conversations of their own.": "Le risposte dei membri arrivano come conversazioni a sé.",
  "Message": "Messaggio",
  "Message (optional)": "Messaggio (facoltativo)",
  "Message the seller about your order and get told when they reply.": "Scrivi al venditore sul tuo ordine e ricevi un avviso quando risponde.",
  "Message to {shop}": "Messaggio a {shop}",
  "Message to the shops": "Messaggio ai negozi",
  "Messages": "Messaggi",
  "Messages can't be reached right now.": "I messaggi non sono raggiungibili in questo momento.",
  "My Johku": "My Johku",
  "Name, sign-in and deleting the account": "Nome, accesso ed eliminazione dell'account",
  "New conversation": "Nuova conversazione",
  "New incident": "Nuovo disservizio",
  "New message from {name} in Johku Hub": "Nuovo messaggio da {name} su Johku Hub",
  "New message from {shop}": "Nuovo messaggio da {shop}",
  "New message: {shop}, order {order}": "Nuovo messaggio: {shop}, ordine {order}",
  "New messages in Johku Hub": "Nuovi messaggi in Johku Hub",
  "Next up": "Prossimo",
  "No connection. Check the connection and try again.": "Nessuna connessione. Controlla la connessione e riprova.",
  "No conversations yet": "Ancora nessuna conversazione",
  "No conversations yet. Start one with the pen above.": "Ancora nessuna conversazione. Iniziane una con la penna qui sopra.",
  "No email? It can take a minute. Check the spam folder too.": "Nessuna email? Può volerci un minuto. Controlla anche la cartella spam.",
  "No incidents in the last 30 days.": "Nessun disservizio negli ultimi 30 giorni.",
  "No matches.": "Nessun risultato.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Ancora nessun messaggio su questo ordine. Il cliente riceve un'email con un link alla pagina dell'ordine, dove può leggere e rispondere.",
  "No messages yet": "Ancora nessun messaggio",
  "No messages yet.": "Ancora nessun messaggio.",
  "No shows match.": "Nessuno spettacolo corrisponde.",
  "No tickets start today for these.": "Per queste non inizia nessun biglietto oggi.",
  "No valid codes": "Nessun codice valido",
  "None of the shop's collections has members yet.": "Nessuna collezione del negozio ha ancora membri.",
  "Not a valid ticket": "Biglietto non valido",
  "Not sent: {error}": "Non inviato: {error}",
  "Not shown yet": "Non ancora visibile",
  "Not working": "Non funziona",
  "Nothing matches “{query}”.": "Nessun risultato per “{query}”.",
  "Nothing to scan from today on.": "Niente da scansionare da oggi in poi.",
  "Notice": "Avviso",
  "Notifications are blocked for this site in the browser's settings.": "Le notifiche sono bloccate per questo sito nelle impostazioni del browser.",
  "Notifications are off for Johku Hub in the phone's settings.": "Le notifiche di Johku Hub sono disattivate nelle impostazioni del telefono.",
  "Notifications of new messages: {name}": "Notifiche dei nuovi messaggi: {name}",
  "Now": "Adesso",
  "Offer a sales channel": "Offri un canale di vendita",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Offerta: vendete i vostri prodotti su {channel} con una commissione del {commission} %.",
  "Offline": "Offline",
  "Offline. {n} message will send when the connection returns.": "Offline. {n} messaggio verrà inviato quando la connessione tornerà.",
  "Offline. {n} messages will send when the connection returns.": "Offline. {n} messaggi verranno inviati quando la connessione tornerà.",
  "Offline. Messages will send when the connection returns.": "Offline. I messaggi verranno inviati quando la connessione tornerà.",
  "Offline. These are the codes saved on this phone ({time}).": "Offline. Questi sono i codici salvati su questo telefono ({time}).",
  "Offline. These are the orders saved on this phone.": "Offline. Questi sono gli ordini salvati su questo telefono.",
  "Offline. These are the tickets saved on this phone ({time}).": "Offline. Questi sono i biglietti salvati su questo telefono ({time}).",
  "OK": "OK",
  "One use": "Un utilizzo",
  "Only for {name}: check their ID.": "Solo per {name}: controlla il documento.",
  "Only the shop's users who can use the POS can scan its tickets.": "Solo gli utenti del negozio che possono usare la cassa possono scansionarne i biglietti.",
  "Only your own sign-in: your shop and its Johku agreement are managed in Johku App.": "Solo il tuo accesso personale: il tuo negozio e il suo contratto Johku si gestiscono in Johku App.",
  "Open Johku App": "Apri Johku App",
  "Open the order": "Apri l'ordine",
  "Open the order in the shop": "Apri l'ordine nel negozio",
  "Opening…": "Apertura…",
  "Opens in a new tab": "Si apre in una nuova scheda",
  "Order": "Ordine",
  "Order {id}": "Ordine {id}",
  "Orders": "Ordini",
  "Other merchants": "Altri commercianti",
  "Other merchants find {shop}": "Gli altri commercianti trovano {shop}",
  "Other orders": "Altri ordini",
  "Paid": "Pagato",
  "Partly working": "Funziona in parte",
  "Pictures, PDF, text, Word and Excel files only": "Solo immagini e file PDF, di testo, Word ed Excel",
  "PIN code": "Codice PIN",
  "PIN codes": "Codici PIN",
  "Point the camera at a ticket's code.": "Inquadra il codice di un biglietto.",
  "Privacy policy": "Informativa sulla privacy",
  "Private message": "Messaggio privato",
  "Questions about your order? The shop's answer comes to Messages.": "Domande sul tuo ordine? La risposta del negozio arriva in Messaggi.",
  "Read and reply: {url}": "Leggi e rispondi: {url}",
  "Read and search your conversations": "Leggere e cercare nelle tue conversazioni",
  "Reader settings": "Impostazioni del lettore",
  "Ready for the next ticket.": "Pronto per il prossimo biglietto.",
  "Recent": "Recenti",
  "Recipient": "Destinatario",
  "Refunded": "Rimborsato",
  "Reload": "Ricarica",
  "Remove": "Rimuovi",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Rispondi nell'app Johku o su {url}, accedendo con questo indirizzo email.",
  "Resolved": "Risolto",
  "Resolved: {title}": "Risolto: {title}",
  "Resources": "Risorse",
  "Row {row}, seat {seat}": "Fila {row}, posto {seat}",
  "Sales channel offer": "Offerta di canale di vendita",
  "Save": "Salva",
  "Saved in Downloads": "Salvato in Download",
  "Saving files needs Android 10 or newer": "Per salvare i file serve Android 10 o successivo",
  "Scan a ticket with your scanner.": "Scansiona un biglietto con il tuo scanner.",
  "Scan for {n} show": "Scansiona per {n} spettacolo",
  "Scan for {n} shows": "Scansiona per {n} spettacoli",
  "Scan for {n} start time": "Scansiona per {n} orario",
  "Scan for {n} start times": "Scansiona per {n} orari",
  "Scan tickets": "Scansiona biglietti",
  "Search": "Cerca",
  "Search by name": "Cerca per nome",
  "Search conversations": "Cerca nelle conversazioni",
  "Search shows": "Cerca spettacoli",
  "Seat": "Posto a sedere",
  "Seat {seat}": "Posto {seat}",
  "See all": "Vedi tutto",
  "Sell, check tickets and answer customers in Johku App.": "Vendi, controlla i biglietti e rispondi ai clienti in Johku App.",
  "Send": "Invia",
  "Send as": "Invia come",
  "Send code": "Invia codice",
  "Send messages and start conversations as you": "Inviare messaggi e avviare conversazioni a tuo nome",
  "Send now": "Invia ora",
  "Send the offer": "Invia l'offerta",
  "Send to members": "Invia ai membri",
  "Send to shops": "Invia ai negozi",
  "Send update": "Invia aggiornamento",
  "Sending…": "Invio…",
  "Sent to {done} of {n} people": "Inviato a {done} di {n} persone",
  "Sent to {done} of {n} person": "Inviato a {done} di {n} persona",
  "Severity": "Gravità",
  "Shop": "Negozio",
  "Show booking": "Mostra la prenotazione",
  "Show conversations of": "Mostra le conversazioni di",
  "Show more": "Mostra altro",
  "Show orders of": "Mostra gli ordini di",
  "Show the code at the door.": "Mostra il codice all'ingresso.",
  "Show the code at the till, or type it in the shop's online store.": "Mostra il codice alla cassa o inseriscilo nel negozio online.",
  "Show tickets": "Mostra i biglietti",
  "Show used and expired codes": "Mostra i codici usati e scaduti",
  "Shows": "Spettacoli",
  "Sign in": "Accedi",
  "Sign in again": "Accedi di nuovo",
  "Sign in to Johku Hub": "Accedi a Johku Hub",
  "Sign in with an email code": "Accedi con un codice via email",
  "Sign in with Johku": "Accedi con Johku",
  "Sign out": "Esci",
  "Sign out of {email}? Its messages are removed from this device.": "Uscire da {email}? I suoi messaggi verranno rimossi da questo dispositivo.",
  "Sign out of this account": "Esci da questo account",
  "Sign out?": "Uscire?",
  "Signing in with Johku didn't finish. Please try again.": "L'accesso con Johku non è stato completato. Riprova.",
  "Signing in with Johku didn't work ({error}).": "L'accesso con Johku non ha funzionato ({error}).",
  "Signing in…": "Accesso in corso…",
  "So you see customers' questions right away": "Così vedi subito le domande dei clienti",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Alcuni negozi non hanno risposto, quindi i loro codici potrebbero mancare: {shops}",
  "Someone": "Qualcuno",
  "Something went wrong.": "Qualcosa è andato storto.",
  "Something went wrong. Please try again.": "Si è verificato un errore. Riprova.",
  "Something went wrong. Try again in a moment.": "Qualcosa è andato storto. Riprova tra poco.",
  "Sounds": "Suoni",
  "Start the conversation": "Inizia la conversazione",
  "Start times today": "Orari di inizio oggi",
  "Status": "Stato",
  "Subject (optional)": "Oggetto (facoltativo)",
  "Support": "Supporto",
  "Swipe for the next one": "Scorri per il successivo",
  "Switch camera": "Cambia fotocamera",
  "Switch shop": "Cambia negozio",
  "That code has expired. Ask for a new one.": "Quel codice è scaduto. Richiedine uno nuovo.",
  "That code isn't right. Check it and try again.": "Quel codice non è corretto. Controllalo e riprova.",
  "That didn't go through. Try again in a moment.": "Non è andato a buon fine. Riprova tra un momento.",
  "The booking isn't confirmed.": "La prenotazione non è confermata.",
  "The camera didn't start.": "La fotocamera non si è avviata.",
  "The code is on its way. Check again in a moment.": "Il codice è in arrivo. Controlla di nuovo tra poco.",
  "The conversation was declined.": "La conversazione è stata rifiutata.",
  "The device's language": "Lingua del dispositivo",
  "The download failed": "Download non riuscito",
  "The file is larger than 20 MB": "Il file supera i 20 MB",
  "The Johku team": "Il team Johku",
  "The Johku team keeps you posted here until it's resolved.": "Il team Johku ti terrà aggiornato qui fino alla risoluzione.",
  "The order page can't be opened right now. Try again in a moment.": "Al momento non è possibile aprire la pagina dell'ordine. Riprova tra poco.",
  "The PIN code and instructions show from {time}.": "Il codice PIN e le istruzioni sono visibili dal {time}.",
  "The shop can't be reached about this order from here. Try its order page.": "Da qui non è possibile contattare il negozio per questo ordine. Prova dalla pagina dell'ordine.",
  "The ticket couldn't be confirmed. Scan it again.": "Non è stato possibile confermare il biglietto. Scansionalo di nuovo.",
  "The ticket is for {what}.": "Il biglietto è per {what}.",
  "The ticket is for another place.": "Il biglietto è per un altro luogo.",
  "The ticket is for another shop.": "Il biglietto è di un altro negozio.",
  "The ticket is for another show.": "Il biglietto è per un altro spettacolo.",
  "The ticket is for another time.": "Il biglietto è per un altro orario.",
  "The tickets can't be opened right now. Try again in a moment.": "Al momento non è possibile aprire i biglietti. Riprova tra poco.",
  "There's no one {name} can write to yet.": "Non c'è ancora nessuno a cui {name} possa scrivere.",
  "These tickets aren't available any more.": "Questi biglietti non sono più disponibili.",
  "this account": "questo account",
  "This browser can't read codes with the camera. Use the Johku Hub app, or a scanner (settings).": "Questo browser non può leggere i codici con la fotocamera. Usa l'app Johku Hub o uno scanner (impostazioni).",
  "This device has no camera.": "Questo dispositivo non ha una fotocamera.",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Verrà inviato ora al personale di {n} negozio, tramite notifica ed email. Inviare?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Verrà inviato ora al personale di {n} negozi, tramite notifica ed email. Inviare?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Verrà inviato ora al personale di tutti i negozi, tramite notifica ed email. Inviare?",
  "This incident isn't shown any more.": "Questo disservizio non viene più mostrato.",
  "This order has been cancelled. Its tickets aren't valid.": "Questo ordine è stato annullato. I suoi biglietti non sono validi.",
  "This order has been refunded. Its tickets aren't valid.": "Questo ordine è stato rimborsato. I suoi biglietti non sono validi.",
  "Ticket": "Biglietto",
  "Ticket {n} of {total}": "Biglietto {n} di {total}",
  "Tickets": "Biglietti",
  "Tickets at hand": "Biglietti sempre a portata di mano",
  "To (email)": "A (email)",
  "To members": "Ai membri",
  "To the members of {collection}: {n} member": "Ai membri di {collection}: {n} membro",
  "To the members of {collection}: {n} members": "Ai membri di {collection}: {n} membri",
  "To the members of {collection}: sending, {sent}/{n}": "Ai membri di {collection}: invio in corso, {sent}/{n}",
  "Today": "Oggi",
  "Tomorrow": "Domani",
  "Total": "Totale",
  "Try again": "Riprova",
  "Turn on notifications": "Attiva le notifiche",
  "Unpaid": "Non pagato",
  "Upcoming": "In arrivo",
  "Update to the shops": "Aggiornamento ai negozi",
  "Use a scanner instead of the camera": "Usa uno scanner invece della fotocamera",
  "Use another address": "Usa un altro indirizzo",
  "Used": "Utilizzato",
  "Uses": "Utilizzi",
  "Valid from {date}": "Valido dal {date}",
  "Valid until {date}": "Valido fino al {date}",
  "Validity": "Validità",
  "Value left": "Valore residuo",
  "Venue": "Luogo",
  "Vibration": "Vibrazione",
  "Waiting for {shop} to accept the conversation.": "In attesa che {shop} accetti la conversazione.",
  "Waiting for an answer": "In attesa di risposta",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Ti invieremo un codice di accesso via email. Usa l'indirizzo che usi con Johku.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Cosa non funziona, chi riguarda e cosa fare nel frattempo.",
  "What you offer, and what kind of partners you look for": "Cosa offrite e che tipo di partner cercate",
  "What's wrong": "Cosa non va",
  "When": "Quando",
  "When something in Johku doesn't work, and when it's fixed": "Quando qualcosa su Johku non funziona, e quando è risolto",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "Quando acquisti in un negozio Johku con {email}, l'ordine compare qui automaticamente.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "Quando acquisti in un negozio Johku con la tua email, l'ordine compare qui automaticamente.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Se gli altri commercianti Johku trovano il tuo negozio e possono invitarlo a una conversazione",
  "With the customer": "Con il cliente",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Con la tua email, Google o Microsoft, come nei negozi online Johku.",
  "Withdraw the offer": "Ritira l'offerta",
  "Withdrawn": "Ritirata",
  "Withdrew the offer.": "Ha ritirato l'offerta.",
  "Write a message": "Scrivi un messaggio",
  "Write to the customer": "Scrivi al cliente",
  "Write to the shop": "Scrivi al negozio",
  "Yesterday": "Ieri",
  "You": "Tu",
  "You can close this page.": "Puoi chiudere questa pagina.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Ricevi questo messaggio perché lavori in un negozio che usa Johku. Segui la situazione nell'app Johku o su {url}.",
  "You: ": "Tu: ",
  "You'll see replies without opening the app.": "Vedrai le risposte senza aprire l'app.",
  "You're offline. A new conversation needs a connection.": "Sei offline. Per una nuova conversazione serve una connessione.",
  "You're offline. Checking in and out needs a connection.": "Sei offline. Check-in e check-out richiedono una connessione.",
  "You're offline. The first message needs a connection.": "Sei offline. Per il primo messaggio serve una connessione.",
  "You're offline. Try again when the connection returns.": "Sei offline. Riprova quando torna la connessione.",
  "You're staff at {shop}": "Fai parte dello staff di {shop}",
  "Your codes can't be loaded right now. Try again in a moment.": "Al momento non è possibile caricare i tuoi codici. Riprova tra poco.",
  "Your conversations with shops about your orders show up here.": "Le tue conversazioni con i negozi sui tuoi ordini compaiono qui.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Il tuo account Johku non ha ancora accesso a Johku Hub.",
  "Your Johku Hub sign-in code is {code}.": "Il tuo codice di accesso a Johku Hub è {code}.",
  "Your orders": "I tuoi ordini",
  "Your orders can't be loaded right now. Try again in a moment.": "Al momento non è possibile caricare i tuoi ordini. Riprova tra poco.",
  "Your other accounts stay signed in.": "Gli altri tuoi account restano connessi.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "Gli altri tuoi account restano connessi. Passa dall'uno all'altro dalla tua immagine nella Home.",
  "Your session for {account} has ended. Please sign in again.": "La tua sessione per {account} è scaduta. Accedi di nuovo.",
  "Your shop": "Il tuo negozio",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Il tuo negozio non ha un canale di vendita su Johku. Configuralo prima nelle impostazioni dell'app Johku.",
  "Your shops": "I tuoi negozi",
  "Your tickets will show up here": "I tuoi biglietti compariranno qui",
  "Your tickets, orders and messages with shops": "I tuoi biglietti, ordini e messaggi con i negozi"
}
